
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateMontageplanNoteDtoFormGroup() {
return new FormGroup({
    montageplanNote: new FormControl<string | undefined>(undefined, [Validators.maxLength(2000)]),
})
;
}
      